import { render, staticRenderFns } from "./RefertazioneEcocardioList.vue?vue&type=template&id=03eff8fa"
import script from "./RefertazioneEcocardioList.vue?vue&type=script&lang=js"
export * from "./RefertazioneEcocardioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports